import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "emp-notice-detail" }
const _hoisted_2 = { class: "emp-header" }
const _hoisted_3 = { class: "emp-content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = { class: "notice-card" }
const _hoisted_6 = { class: "notice-header" }
const _hoisted_7 = { class: "category-row" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-admin"
}
const _hoisted_9 = { class: "notice-title" }
const _hoisted_10 = { class: "notice-meta" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "notice-files"
}
const _hoisted_13 = { class: "files-title" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "other-notices" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "list-title" }
const _hoisted_18 = { class: "list-author" }
const _hoisted_19 = { class: "list-date" }
const _hoisted_20 = {
  key: 2,
  class: "error-container"
}

import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';

interface Notice {
  nc_idx: number;
  nc_type: 'ADMIN' | 'CENTER';
  nc_category: string;
  nc_sisul_name: string | null;
  nc_title: string;
  nc_content: string;
  nc_hit: number;
  nc_wdate: string;
}

interface NoticeFile { nf_idx: number; nf_original_name: string; nf_type: string; }


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpNoticeDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const loading = ref(true);
const notice = ref<Notice | null>(null);
const files = ref<NoticeFile[]>([]);
const otherNotices = ref<Notice[]>([]);

const loadNotice = async () => {
  const ncIdx = route.params.ncIdx;
  loading.value = true;
  
  try {
    const [detailRes, listRes] = await Promise.all([
      axios.get(`/api/notice/detail/${ncIdx}`, { withCredentials: true }),
      axios.get('/api/notice/list', { params: { page: 1, limit: 10 }, withCredentials: true })
    ]);
    
    if (detailRes.data.success) {
      notice.value = detailRes.data.notice;
      files.value = detailRes.data.files || [];
    }
    
    if (listRes.data.success) {
      otherNotices.value = listRes.data.notices;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  } finally {
    loading.value = false;
  }
};

const goBack = () => router.back();
const goToNotice = (item: Notice | null) => { if (item) router.replace(`/emp/notice/${item.nc_idx}`); };
const downloadFile = (file: NoticeFile) => window.open(`/api/notice/download/${file.nf_idx}`, '_blank');

const formatDate = (d: string) => d ? new Date(d).toLocaleDateString('ko-KR') : '-';
const formatShortDate = (d: string) => d ? `${new Date(d).getMonth()+1}/${new Date(d).getDate()}` : '';
const formatListDate = (d: string) => {
  if (!d) return '-';
  const date = new Date(d);
  return `${date.getFullYear()}.${String(date.getMonth()+1).padStart(2,'0')}.${String(date.getDate()).padStart(2,'0')}`;
};
const getCategoryText = (c: string) => ({ NOTICE: '공지', UPDATE: '업데이트', EVENT: '이벤트', URGENT: '긴급' }[c] || c);
const getCategoryShort = (c: string) => ({ NOTICE: '공지', UPDATE: '업뎃', EVENT: '행사', URGENT: '긴급' }[c] || c);

watch(() => route.params.ncIdx, () => loadNotice());
onMounted(() => loadNotice());

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: goBack
      }, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-title" }, "공지사항", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "28"
            })
          ]))
        : (notice.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['badge', `badge-${notice.value.nc_category.toLowerCase()}`])
                    }, _toDisplayString(getCategoryText(notice.value.nc_category)), 3),
                    (notice.value.nc_type === 'ADMIN')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "전체"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(notice.value.nc_title), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(notice.value.nc_type === 'ADMIN' ? '관리자' : notice.value.nc_sisul_name || '-') + " ", 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "dot" }, "·", -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(notice.value.nc_wdate)) + " ", 1),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "dot" }, "·", -1)),
                    _createTextVNode(" 조회 " + _toDisplayString(notice.value.nc_hit), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "notice-body ql-editor",
                  innerHTML: notice.value.nc_content
                }, null, 8, _hoisted_11),
                (files.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, "첨부파일 (" + _toDisplayString(files.value.length) + ")", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: file.nf_idx,
                          class: "file-item",
                          onClick: ($event: any) => (downloadFile(file))
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-file", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", null, _toDisplayString(file.nf_original_name), 1),
                          _createVNode(_component_v_icon, {
                            size: "16",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-download", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_14))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "section-title" }, "공지사항 목록", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherNotices.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.nc_idx,
                    class: _normalizeClass(["list-item", { active: item.nc_idx === notice.value.nc_idx }]),
                    onClick: ($event: any) => (goToNotice(item))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['mini-badge', `badge-${item.nc_category.toLowerCase()}`])
                    }, _toDisplayString(getCategoryShort(item.nc_category)), 3),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.nc_title), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.nc_type === 'ADMIN' ? '관리자' : item.nc_sisul_name || '-'), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(formatListDate(item.nc_wdate)), 1)
                  ], 10, _hoisted_16))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_v_icon, {
                size: "40",
                color: "#ccc"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-alert-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "공지사항을 찾을 수 없습니다", -1))
            ]))
    ])
  ]))
}
}

})